import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { findVeiculosOptions } from 'store/veiculo/actions';
import { getVeiculosOptions } from 'store/veiculo/reducer';
import DefaultSelectV2 from '../DefaultSelectV2';
import SearchSelectV2 from '../SearchSelectV2';

const VeiculoSelectV2 = ({
  veiculosOptions,
  onSelect,
  value,
  isRequired,
  error,
  helperText,
  findVeiculosOptions,
  disabled,
  multiSelect,
  label,
}) => {
  useEffect(() => {
    findVeiculosOptions(true);
  }, [findVeiculosOptions]);

  const searchOptions = useMemo(
    () =>
      (veiculosOptions || []).map((v) => ({
        value: v.id,
        label: v.placa,
      })),
    [veiculosOptions],
  );

  if (multiSelect) {
    return (
      <SearchSelectV2
        label={label}
        multiSelect
        disabled={disabled}
        options={searchOptions}
        error={error}
        isRequired={isRequired}
        onSelect={onSelect}
        value={value}
      />
    );
  }

  const handleChange = (event) => onSelect(event.target.value);

  return (
    <DefaultSelectV2
      error={error}
      disabled={disabled}
      helperText={helperText}
      isRequired={isRequired}
      label={label}
      optionLabel="placa"
      onSelect={handleChange}
      options={veiculosOptions || []}
      showEmpty
      value={value}
    />
  );
};

VeiculoSelectV2.propTypes = {
  error: PropTypes.bool,
  /** Single: string ID; multi: array of IDs */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ]),
  veiculosOptions: PropTypes.array.isRequired,
  helperText: PropTypes.string,
  isRequired: PropTypes.any,
  /** Single: `(id:string) => void`; multi: `(ids:string[] | null) => void` */
  onSelect: PropTypes.func.isRequired,
  findVeiculosOptions: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  multiSelect: PropTypes.bool,
  label: PropTypes.string,
};

VeiculoSelectV2.defaultProps = {
  error: false,
  helperText: null,
  isRequired: false,
  disabled: false,
  multiSelect: false,
  label: 'Veículos',
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ findVeiculosOptions }, dispatch);
const mapStateToProps = (state) => ({ veiculosOptions: getVeiculosOptions(state) });

export default connect(mapStateToProps, mapDispatchToProps)(VeiculoSelectV2);
